import React, { useRef }           from "react";
import PropTypes                   from "prop-types";
import style                       from './Tile.module.less';
import {t}                         from '../../../MyVisitX/Mediathek/MediathekHelper.js';
import VXButton                    from '../../../SimpleElements/VXButton/VXButton';
import {VXButtonLineConfig}        from '../../../SimpleElements/VXButton/VXButtonConfig';
import {COLOR_TYPE_CALL_TO_ACTION} from '../../../SimpleElements/VXButton/ButtonHelper';
import ReloadHelper                from '../../../../utils/ReloadHelper';
import {onClickProfile}            from './Helper';
import VXButtonOutline             from "../../../SimpleElements/VXButton/Presets/VXButtonOutline.js";
import STYLES                      from "../../../SimpleElements/VXButton/EnumVXButton.js";
import Flux                        from "../../../../flux/Flux.js";


const Footer = (props) => {
    const {model, title, description, linkVX, button} = props;
    const [showMoreButton, setShowMoreButton] = React.useState(button || linkVX);
    const [isExpand, setIsExpand] = React.useState(props.isExpand || false);

    const descriptionRef = useRef(null);
    const showFallback   = isExpand && !model?.linkVX;
    const showDetail     = isExpand && model?.linkVX && linkVX;

    const showDescription = props.originType !== Flux.Constants.Mediathek.OriginType.CHATCLIP;

    const setTileRef = (ref) => {
        if (ref) {
            setTimeout(() => {
                if (descriptionRef.current?.getBoundingClientRect().width >= ref.getBoundingClientRect().width - 80) {
                    setShowMoreButton(true);
                }
            }, 0);
        }
    };

    const onButtonClick = () => {
        ReloadHelper.reload(linkVX);
    };

    return <div className={style.tileFooter} ref={(ref) => setTileRef(ref)}>
        <div className={style.tileFooterContent}>
            {model?.name && <a href={model?.linkVX} className={style.tileFooterModelName} onClick={(e) => onClickProfile(e, model?.linkVX)}>
                {model?.name}
                {model?.online && <span className={style.tileFooterOnlineBadge}>LIVE</span>}
            </a>}
            <div className={style.tileFooterTitle}>{title}</div>
            {showDescription && <div className={style.tileFooterDescriptionWrapper}>
                <div className={(isExpand ? "" : style.tileFooterDescriptionHide)} ref={descriptionRef}>{description}</div>
                {!isExpand && showMoreButton &&
                        <span className={style['tile__footer-description-more']} onClick={() => setIsExpand(true)}>{t('button-more')}</span>}
            </div>}
            {showDescription && showFallback && <div className={style.tileFooterDescriptionFallback}>
                <i className="icon -icon-round-info-full" />&nbsp;{t('fallback-desc-video')}
            </div>}
            {showDetail && showDescription && <div className={style.tileFooterButtonWrapper + (button ? " " + style.tileFooterButtonWrapperButtons : "")}>
                {button}
                {button ? <VXButtonOutline line1={[new VXButtonLineConfig(t('button-detail'))]}
                                           border={STYLES.BORDER.NONE}
                                           onClick={onButtonClick} /> :
                        <VXButton line1={[new VXButtonLineConfig(t('button-detail'))]}
                                  color={COLOR_TYPE_CALL_TO_ACTION}
                                  onClick={onButtonClick} />
                }
            </div>}
        </div>
    </div>;
};


Footer.propTypes = {
    model: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    linkVX: PropTypes.string,
    tileRef: PropTypes.object,
    onClickProfile: PropTypes.func,
    button: PropTypes.node,
    isExpand: PropTypes.bool,
    originType: PropTypes.string,
};


export default Footer;
